import { get } from 'idb-keyval';
import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export const REQUEST_TIMEOUT_MS = 60_000;

const instance: AxiosInstance = axios.create({
    baseURL: '__API_URL__',
    timeout: REQUEST_TIMEOUT_MS,
});

/** The bearer token and the tenancy headers every authenticated gateway call needs. */
export function sessionHeaders(
    { accessToken, parent, serviceParent, person }: Record<string, any> = {},
): Record<string, string> {
    const headers: Record<string, string> = {};

    if (accessToken) {
        headers['Authorization'] = `Bearer ${ accessToken }`;
    }

    if (parent) {
        headers['BaseParent'] = parent;
        headers['Parent'] = parent;
    }

    if (person) {
        headers['Person'] = person.id;
    }

    if (serviceParent) {
        headers['ServiceParent'] = serviceParent;
    }

    return headers;
}

instance.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    Object.assign(config.headers, sessionHeaders(await get('user') ?? {}));

    return config;
});

// A timeout or dropped connection leaves no response to read .status from.
export function handleResponseError(error: any): Promise<never> {
    if (401 === error?.response?.status) {
        window.location.replace('/auth/login');
    }

    return Promise.reject(error);
}

instance.interceptors.response.use(
    value => Promise.resolve(value),
    handleResponseError,
);

export function useApiClient() {
    return instance;
}